import { useState } from "react";
import { ThemeContext } from "./index";

export const ThemeProvider = ({ children }) => {
  const [themeName, setThemeName] = useState(
    localStorage.getItem("dotdoggoTheme") || "dark"
  );

  const toggleTheme = () => {
    const theme = themeName === "dark" ? "light" : "dark";
    setThemeName(theme);
    localStorage.setItem("dotdoggoTheme", theme);
  };

  return (
    <ThemeContext.Provider
      value={{
        themeName,
        isDarkMode: themeName === "dark",
        toggleTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
